import { fetchResource } from "../helpers/network";
import {
  setErrorNotification,
  setSuccessNotification
} from "../actions/notifications";

export const REQUEST_ACCOUNT_SETTINGS = "REQUEST_ACCOUNT_SETTINGS";
export const RECEIVE_ACCOUNT_SETTINGS = "RECEIVE_ACCOUNT_SETTINGS";
export const RECEIVE_ACCOUNT_SETTINGS_FAILED =
  "RECEIVE_ACCOUNT_SETTINGS_FAILED";
export const CLEAR_ACCOUNT_SETTINGS = "CLEAR_ACCOUNT_SETTINGS";
export const NEW_ACCOUNT_SETTINGS = "NEW_ACCOUNT_SETTINGS";
export const EDIT_ACCOUNT_SETTINGS = "EDIT_ACCOUNT_SETTINGS";
export const CANCEL_EDIT_ACCOUNT_SETTINGS = "CANCEL_EDIT_ACCOUNT_SETTINGS";
export const PATCH_EDIT_ACCOUNT_SETTINGS = "PATCH_EDIT_ACCOUNT_SETTINGS";

export const requestAccountSettings = () => ({
  type: REQUEST_ACCOUNT_SETTINGS
});

export const receiveAccountSettings = accountSettings => ({
  type: RECEIVE_ACCOUNT_SETTINGS,
  accountSettings: accountSettings.data
});

export const receiveAccountSettingsFailed = () => ({
  type: RECEIVE_ACCOUNT_SETTINGS_FAILED
});

export const cancelEditAccountSettings = () => ({
  type: CANCEL_EDIT_ACCOUNT_SETTINGS
});

export const patchEditAccountSettings = patch => ({
  type: PATCH_EDIT_ACCOUNT_SETTINGS,
  patch
});

export const clearAccountSettings = () => ({
  type: CLEAR_ACCOUNT_SETTINGS
});

export const fetchAccountSettings = (id, params) => {
  const paramsWithPath = {
    ...params,
    path: `/account_settings/${id}`
  };
  return function(dispatch) {
    return dispatch(
      fetchResource(
        paramsWithPath,
        requestAccountSettings,
        receiveAccountSettings,
        receiveAccountSettingsFailed
      )
    );
  };
};

export function postAccountSettings(params) {
  const paramsWithPath = {
    ...params,
    path: "/account_settings",
    method: "POST"
  };
  return function(dispatch) {
    return dispatch(
      fetchResource(
        paramsWithPath,
        () => {
          dispatch(setSuccessNotification("Created Account Settings", null));
          return requestAccountSettings;
        },
        receiveAccountSettings,
        setErrorNotification
      )
    );
  };
}

export function putAccountSettings(id, params) {
  const paramsWithPath = Object.assign({}, params, {
    method: "PUT",
    path: `/account_settings/${id}`
  });
  return function(dispatch) {
    return dispatch(
      fetchResource(
        paramsWithPath,
        null,
        json => {
          dispatch(setSuccessNotification("Updated Account Settings", null));
          dispatch(cancelEditAccountSettings());
          return receiveAccountSettings(json);
        },
        setErrorNotification
      )
    );
  };
}

export function deleteAccountSettings(id) {
  const paramsWithPath = Object.assign(
    {},
    {
      method: "DELETE",
      path: `/account_settings/${id}`
    }
  );
  return function(dispatch) {
    return dispatch(
      fetchResource(
        paramsWithPath,
        null,
        () => {
          dispatch(cancelEditAccountSettings());
          dispatch(fetchAccountSettings(id));
          return setSuccessNotification("Deleted Account Settings", null);
        },
        setErrorNotification
      )
    );
  };
}

export function createAccountSettings() {
  return (dispatch, getState) => {
    const state = getState();
    const {
      accountId,
      maxInstances,
      maxSyncers,
      chargeThreshold
    } = state.modalForm.editAccountSettings;

    const body = {
      accountId,
      maxInstances: parseInt(maxInstances, 10),
      maxSyncers: parseInt(maxSyncers, 10)
    };
    if (typeof chargeThreshold !== "undefined") {
      body.chargeThreshold = chargeThreshold.toString();
    }
    const params = {
      body: { ...body }
    };
    return dispatch(postAccountSettings(params));
  };
}

export function updateAccountSettings() {
  return (dispatch, getState) => {
    const state = getState();
    const {
      maxInstances,
      maxSyncers,
      chargeThreshold
    } = state.modalForm.editAccountSettings;
    const { id, accountId } = state.entities.accountSettings;

    const body = {
      id,
      accountId,
      maxInstances: parseInt(maxInstances, 10),
      maxSyncers: parseInt(maxSyncers, 10),
      chargeThreshold: chargeThreshold || "500"
    };
    const params = {
      body: { ...body }
    };
    return dispatch(putAccountSettings(accountId, params));
  };
}

export function destroyAccountSettings() {
  return (dispatch, getState) => {
    const state = getState();
    const { accountId } = state.entities.accountSettings;
    return dispatch(deleteAccountSettings(accountId));
  };
}

export const editAccountSettings = id => {
  return function(dispatch, getState) {
    const state = getState();
    const accountSettingsEntity = state.entities.accountSettings;
    const useLimits = Object.keys(accountSettingsEntity).length > 0;
    const accountSettings = {
      id,
      ...accountSettingsEntity,
      useLimits
    };
    return dispatch({
      type: EDIT_ACCOUNT_SETTINGS,
      accountSettings
    });
  };
};

export const newAccountSettings = accountId => ({
  type: NEW_ACCOUNT_SETTINGS,
  accountId
});

export function saveAccountSettingsBeingEdited() {
  return function(dispatch, getState) {
    const state = getState();
    const {
      id,
      useLimits,
      maxInstances,
      maxSyncers,
      chargeThreshold
    } = state.modalForm.editAccountSettings;

    const accountSettingsEntity = { ...state.entities.accountSettings };
    const accountSettingsEntityHasProperties =
      typeof accountSettingsEntity === "object" &&
      Object.keys(accountSettingsEntity).length > 0;

    const isNewAccountSettings = id === "NEW";
    const isExistingAccountSettings =
      typeof id !== "undefined" && accountSettingsEntityHasProperties;

    const hasInvalidFields =
      typeof maxInstances === "undefined" ||
      typeof chargeThreshold === "undefined" ||
      typeof maxSyncers === "undefined" ||
      maxInstances < 1 ||
      maxSyncers < 2 ||
      chargeThreshold < 1;
    const modalHasBeenEdited =
      maxInstances !== accountSettingsEntity.maxInstances ||
      maxSyncers !== accountSettingsEntity.maxSyncers ||
      chargeThreshold !== accountSettingsEntity.chargeThreshold;
    if (
      (isNewAccountSettings && !useLimits) ||
      (useLimits && hasInvalidFields) ||
      (useLimits && isExistingAccountSettings && !modalHasBeenEdited)
    ) {
      return false;
    }
    if (isNewAccountSettings && useLimits) {
      return dispatch(createAccountSettings());
    }
    if (isExistingAccountSettings && !useLimits) {
      return dispatch(destroyAccountSettings());
    }
    if (isExistingAccountSettings && useLimits) {
      return dispatch(updateAccountSettings());
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/accountSettings.js